// Body for the Oscar account order-history list document: the order table
// (date / number / status columns) plus pagination. All copy is hardcoded
// English (the legacy template uses no {% trans %}); this component only
// renders the resolved props.
import { Immutable } from "immer";
import React from "react";
import { t } from "ttag";

import { templates } from "@reactivated";

import { AccountContentTitle } from "../AccountContentTitle";
import { Pagination } from "../Pagination";
import { SideNav } from "../SideNav";

type IProps = Immutable<templates.OrderHistoryDocumentTemplate>;

export const OrderHistoryBody = (props: IProps): React.JSX.Element => {
    const {
        has_nav,
        side_nav,
        content_title,
        phone_display,
        phone_href,
        orders,
        pagination,
        empty_message,
    } = props;
    return (
        <div className="l-capped-width u-margin-bottom--xl u-full-width-title">
            {has_nav && (
                <div className="l-side-nav">
                    <SideNav items={side_nav} />
                </div>
            )}

            <div className="l-side-nav-content">
                <AccountContentTitle
                    contentTitle={content_title}
                    phoneDisplay={phone_display}
                    phoneHref={phone_href}
                />

                <div className="content__copy--full-width">
                    <div className="orders">
                        <ul className="orders__list">
                            <li className="orders__list-item">
                                <div className="orders__list-item__column">
                                    <h2 className="orders__list-item__title">
                                        {t`Order Date`}
                                    </h2>
                                </div>
                                <div className="orders__list-item__column">
                                    <h2 className="orders__list-item__title">
                                        {t`Order Number`}
                                    </h2>
                                </div>
                                <div className="orders__list-item__column">
                                    <h2 className="orders__list-item__title">
                                        {t`Status`}
                                    </h2>
                                </div>
                            </li>
                            {orders.length > 0 ? (
                                <>
                                    {orders.map((order, i) => (
                                        <li
                                            className="orders__list-item"
                                            key={i}
                                        >
                                            <div className="orders__list-item__column">
                                                <p className="orders__list-item__copy">
                                                    {order.date_placed}
                                                </p>
                                            </div>
                                            <div className="orders__list-item__column">
                                                <a
                                                    className="orders__list-item__link"
                                                    href={order.detail_url}
                                                >
                                                    {order.number}
                                                </a>
                                            </div>
                                            <div className="orders__list-item__column">
                                                <p className="orders__list-item__copy">
                                                    {order.status}
                                                </p>
                                                {order.shipments.length > 0 && (
                                                    <div>
                                                        {t`Shipping details:`}
                                                        <br />
                                                        {order.shipments.map(
                                                            (shipment, j) => (
                                                                <React.Fragment
                                                                    key={j}
                                                                >
                                                                    {" "}
                                                                    {t`Shipped`}{" "}
                                                                    {shipment.tracking_url ? (
                                                                        <>
                                                                            :{" "}
                                                                            <a
                                                                                className="orders__list-item__link"
                                                                                href={
                                                                                    shipment.tracking_url
                                                                                }
                                                                            >
                                                                                {t`Track Order`}
                                                                            </a>
                                                                        </>
                                                                    ) : (
                                                                        <>
                                                                            :{" "}
                                                                            {t`Items typically arrive within 5-7 business days.`}
                                                                        </>
                                                                    )}
                                                                </React.Fragment>
                                                            ),
                                                        )}
                                                    </div>
                                                )}
                                            </div>
                                        </li>
                                    ))}
                                    {pagination && (
                                        <Pagination data={pagination} />
                                    )}
                                </>
                            ) : (
                                <li className="orders__list-item">
                                    {empty_message}
                                </li>
                            )}
                        </ul>
                    </div>
                </div>
            </div>
        </div>
    );
};
